import * as React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export interface SearchInputProps extends React.ComponentProps<typeof Input> {
  placeholder?: string;
}

/**
 * SearchInput component for consistent search input styling.
 * Replaces duplicated search input patterns across the app.
 */
export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, placeholder = "Search...", ...props }, ref) => {
    return (
      <div className="h-9 w-full bg-muted rounded-md flex items-center relative overflow-hidden">
        <div className="flex items-center pl-5 pr-3 shrink-0">
          <Search className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="flex-1 pr-6">
          <Input
            ref={ref}
            type="text"
            placeholder={placeholder}
            className={cn(
              "w-full bg-transparent border-0 pl-0 text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 shadow-none pr-0 h-9",
              className
            )}
            {...props}
          />
        </div>
      </div>
    );
  }
);
SearchInput.displayName = "SearchInput";



